  import { 
    HomeIcon, 
    FolderIcon, 
    BriefcaseIcon, 
    WrenchIcon, 
    PencilIcon,
    ArrowDownTrayIcon
  } from "@heroicons/react/24/outline";
  import { motion } from "framer-motion";
  import resume from "../Assets/kishore-resume2025.pdf";

  const Navbar = () => {
    return (
      <div
        className="
          fixed bottom-2 left-1/2 -translate-x-1/2 
          w-[90%] max-w-md sm:max-w-lg
          bg-[#1A1A1A] rounded-full shadow-lg px-4 py-2 flex justify-around items-center
          md:static md:mt-6 md:mx-auto md:max-w-xs  md:translate-x-0
        "
      >
        <NavItem Icon={HomeIcon} link="#home" />
        <NavItem Icon={FolderIcon} link="#projects" />
        <NavItem Icon={BriefcaseIcon} link="#experience" />
        <NavItem Icon={WrenchIcon} link="#skills" />
        <NavItem Icon={PencilIcon} link="#contact" />

        {/* Download Resume with Animation */}
        <motion.a
          href={resume}
          download="Kishore-Resume-2025.pdf"
          whileTap={{ scale: 0.85, rotate: -8 }}
          whileHover={{ scale: 1.2, rotate: 5 }}
          className="p-2 rounded-lg hover:bg-[#222222] transition relative group"
        >
          <ArrowDownTrayIcon className="h-6 w-6 text-white group-hover:text-[#2CBEB5]" />
          {/* Ripple animation */}
          <span className="absolute inset-0 rounded-lg border border-[#2CBEB5] opacity-0 group-hover:animate-ping"></span>
        </motion.a>
      </div>
    );
  };

  const NavItem = ({ Icon, link }) => {
    return (
      <a 
        href={link} 
        className="p-2 rounded-lg hover:bg-[#222222] transition"
      >
        <Icon className="h-6 w-6 text-white" />
      </a>
    );
  };

  export default Navbar;
